(function(angular) {

    angular
        .module('repairforms.config.module')
        .config(I18nConfig);

    I18nConfig.$inject = ['$translateProvider'];

    function I18nConfig($translateProvider) {
        $translateProvider.useUrlLoader('resource/i18n');
        $translateProvider.useSanitizeValueStrategy('escapeParameters');
        $translateProvider.preferredLanguage(getDeviceLanguage());
        $translateProvider.fallbackLanguage('de');
    };

    function getDeviceLanguage() {
        var language = navigator.language || navigator.languages && navigator.languages[0] ||  navigator.userLanguage || 'de';
        return language.slice(0,2);
    };

})(angular);